/**
 * 功能: 向中台同步数据、以及数据比对
 * 同步: 后台编辑器生成的内容数据, 需要向中台导入后显示
 * 数据比对: 通过sha1比对后找出后台和中台差异的数据后进行修复
 */

<template lang="pug">
  div.sync-data
    el-row(type="flex" justify="end")
      el-col(:span="10")
        el-col(:span="5")
          span 当前同步进度
        el-col(:span="14")
          el-progress(:text-inside="true" :stroke-width="20" :percentage="percentage" style="width:300px")
      el-col(:span="10" v-if="syncTotal >= 0")
        p 共有{{ syncTotal || 0 }}篇未同步 上次同步最后更新时间 {{ new Date(lastTime).toLocaleString() }}
      el-col(:span="10" v-else)
        p(v-if="lastTime") 共有{{ total }}篇未同步 上次同步最后更新时间 {{ new Date(lastTime).toLocaleString() }}
      el-col(:span="4" v-if='syncSwitch')
        i.el-icon-loading(style="font-size: 28px; line-height: 32px" v-show="syncing")
        el-button.fr.fr2(type="primary" :size="GLOBAL.SIZE_OF_INPUTBOX" @click="showAbnormalInfo") 全局比对
        el-button.fr(type="primary" :size="GLOBAL.SIZE_OF_INPUTBOX" @click="sync('')" :disabled="syncing") 同步
      el-col(:span="2" v-else)
        el-button.fr(type="info" :size="GLOBAL.SIZE_OF_INPUTBOX" :disabled="true") 同步中
    el-row
      el-table(:data="tableData" style="width: 100%" stripe)
          el-table-column(type="index" width="80")
          el-table-column(label="类型" property="type" width="120")
          el-table-column(label="总个数" property="count" align="center" width="200")
          el-table-column(label="最后更新时间" property="updatedAt")
            template(slot-scope="scope")
              span {{ scope.row.updatedAt | formatTime }}
    abnormal-dialog(ref="AbnormalDialog")
</template>

<script>
import api from '@/apis/export'
import AbnormalDialog from './components/abnormalDialog'
export default {
  components: { AbnormalDialog },
  data () {
    return {
      tableData: [
        { categroy: 'brief', type: '报告' },
        { categroy: 'article', type: '文章' },
        { categroy: 'video', type: '解说' }
      ],
      percentage: 0,
      syncTotal: 0,
      syncing: false,
      lastTime: null,
      syncSwitch: false
    }
  },
  created () {
    this.getSyncData()
  },
  computed: {
    // 计算同步的总数据
    total () {
      const total = this.tableData.reduce(function (total, currentValue, currentIndex, arr) {
        return total + currentValue.count
      }, 0)
      return total || 0
    }
  },
  methods: {
    // 执行数据比对
    showAbnormalInfo () {
      this.$refs.AbnormalDialog.getAbnormalData()
    },
    // 查询需要同步的数据
    getSyncData () {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      api.getSyncData().then(res => {
        if (res.errCode === 0) {
          if (!res.data) {
            this.$notify({
              type: 'success',
              title: '同步完成',
              dangerouslyUseHTMLString: true,
              message: '当前数据已同步完成',
              duration: 0
            })
            return
          }
          this.tableData.map((item, index) => {
            this.tableData[index] = Object.assign({}, item, res.data.data[item.categroy])
            this.syncTotal += res.data.data[item.categroy].count
          })
          // 此行为避免双向绑定问题
          this.tableData = this.tableData.splice(0, this.tableData.length)

          this.lastTime = res.data.lastTime
          this.syncSwitch = res.data.syncSwitch
          const msg = res.data.errMsg
          if (msg) {
            this.$notify({
              type: 'warning',
              title: '上次同步异常数据',
              dangerouslyUseHTMLString: true,
              message: msg,
              duration: 0
            })
          }
        } else {
          this.$notify({
            type: 'warning',
            title: '同步数据失败',
            dangerouslyUseHTMLString: true,
            message: res.msg || '同步失败',
            duration: 0
          })
        }
      }).catch(err => {
        this.$notify({
          type: 'warning',
          title: '同步数据失败',
          dangerouslyUseHTMLString: true,
          message: err.msg || '同步失败',
          duration: 0
        })
      }).finally(() => {
        loading.close()
      })
    },
    // 执行同步流程
    async sync () {
      let timer = null
      if (!this.syncing) {
        this.syncing = true
        timer = setTimeout(() => {
          this.sync()
          clearTimeout(timer)
        }, 1000)
      } else {
        if (this.syncTotal !== 0) {
          const result = await api.syncData()
          if (result.errCode === 0) {
            this.syncTotal--
            this.percentage = Math.round(((this.total - this.syncTotal) / this.total) * 100)
            this.sync()
          } else {
            this.syncing = false
            this.$notify({
              type: 'warning',
              title: '同步数据失败',
              dangerouslyUseHTMLString: true,
              message: result.msg || '同步失败',
              duration: 0
            })
          }
        } else {
          this.syncTotal = 0
          this.tableData.forEach(item => {
            item.total = 0
            item.added = 0
          })
          this.syncing = false
          this.$message({ type: 'success', message: '同步成功' })
        }
      }
    },
    match (val) {
      const index = this.tableData.findIndex(r => r.categroy === val)
      return this.tableData[index].type
    }

  },
  filters: {
    formatTime (val) {
      if (val) {
        return new Date(val).toLocaleString()
      }
    }
  }
}
</script>

<style>
.fr2 {
  margin-left: 5px;
}
</style>
